<template>
  <div style="overflow-y: scroll;height: 100vh;">
    <pre class="pre">{{ txtPre }} </pre>
  </div>
</template>
<style sceped>
.pre {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  padding: 0.3rem;
  font-size: 0.4rem;
}
</style>
<script>
import { Toast } from "mint-ui";
import utils from "@utils/index";
export default {
  name: "file-info",
  data() {
    return {
      txtPre: "",
    };
  },
  created() {
    //清除页面记录
    sessionStorage.removeItem("activeIndex");
    utils.wxAuth().then(() => {
      // 配置js-sdk
      // utils.setJsSdk().then(() => {
      //用户访问开始时间
      if (!utils.getSessionStorage("accessStartTime")) {
        sessionStorage.setItem("accessStartTime", new Date().getTime());
      }
      this.txtURLToBlob();
      // });
    });
  },
  mounted() {
    console.log("hahhhh:", this.$route);
    document.title = decodeURIComponent(this.$route.query.name);
  },
  destroyed() {
    this.interval && clearInterval(this.interval);
    this._behaviorTimeFn();
  },
  methods: {
    //加载优化
    setHashParms() {
      // 增加activeIndex标识用于小程序返回点击2次问题
      if (!utils.isWX()) {
        location.hash =
          "activeIndex=" +
          (!!utils.getSessionStorage("activeIndex")
            ? utils.getSessionStorage("activeIndex")
            : 0);
      }
    },
    //添加页面历史记录，监听popstate事件
    historyPushState() {
      console.log("hahhhh====:", this.$route);
      //（小程序返回需点击两次问题）

      history.pushState({ page: 1 }, null, window.location.href);
      window.addEventListener("popstate", function () {
        console.log(
          "utils.getHashParam('activeIndex')",
          utils.getHashParam("activeIndex"),
          "history",
          history
        );
        if (!utils.getHashParam("activeIndex") || !history.state) {
          wx.miniProgram.navigateBack();
        }
      });
    },

    //预览.txt-文件
    txtURLToBlob() {
      let file_url = decodeURIComponent(this.$route.params.url || "");
      if (!file_url) {
        Toast(`文件地址错误！`);
        return;
      }
      //浏览埋点
      utils.behaviorGatherFn({
        forwardKey: "",
        relationId: this.$route.query.id + "",
        indexType: "file",
        clientType: "weapp",
        extType: "viewFile",
        businessId: this.$route.query.businessId,
        timeStamp: parseFloat(utils.getSessionStorage("accessStartTime") || 0),
      });
      this._reportTimeFn();
      //可以是具体.txt也可以是接口返回的blob，或者web转换
      let xhr = new XMLHttpRequest();
      xhr.open("get", file_url, true);
      xhr.responseType = "blob";
      let self = this; //onload this指向为window中转一下
      this.loading = true;
      xhr.onload = function () {
        if (this.status == 200) {
          self.loading = false;
          console.log(this.response);
          const reader = new FileReader();
          reader.onload = function () {
            // 优化下次加载
            self.setHashParms();
            self.txtPre = reader.result; //获取的数据data
            self.dialogvisibleview = true;
            self.historyPushState();
          };
          reader.readAsText(this.response);
        } else {
          slef.loading = false;
        }
      };
      xhr.send();
    },
    //上报浏览时长
    _reportTimeFn() {
      let self = this;
      self.interval = setInterval(function () {
        self._behaviorTimeFn();
      }, 5000);
    },
    _behaviorTimeFn() {
      var accessStartTime = parseFloat(
        utils.getSessionStorage("accessStartTime") || 0
      );
      utils.behaviorGatherFn({
        forwardKey: "",
        relationId: this.$route.query.id + "",
        indexType: "user_report_time",
        clientType: "weapp",
        extType: "file",
        businessId: this.$route.query.businessId,
        timeStamp: accessStartTime,
        timeLength: (new Date().getTime() - accessStartTime) / 1000,
      });
    },
  },
};
</script>
